export const categories = [
  { slug: "all", name: "全部产品", icon: "ri-apps-line" },
  { slug: "children", name: "儿童系列", icon: "ri-user-smile-line" },
  { slug: "adult", name: "成人系列", icon: "ri-user-line" },
  { slug: "senior", name: "中老年系列", icon: "ri-user-heart-line" },
  { slug: "sport", name: "运动营养", icon: "ri-run-line" },
  { slug: "guide", name: "使用指南", icon: "ri-book-open-line" },
  { slug: "review", name: "用户评测", icon: "ri-chat-quote-line" },
];

export const categoryProducts: Record<string, Array<{ id: string; title: string; image: string; excerpt: string; date: string; category: string; readTime: string }>> = {
  all: [
    {
      id: "product-01",
      title: "爱威奶儿童成长配方——科学营养助力健康成长",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20product%20photography%20of%20a%20carton%20of%20milk%20on%20a%20cream%20colored%20wooden%20surface%20with%20soft%20natural%20window%20light%20casting%20gentle%20shadows%20clean%20elegant%20composition%20with%20a%20small%20plant%20in%20background%20warm%20and%20inviting%20atmosphere&width=800&height=600&seq=cat-prod-01&orientation=landscape",
      excerpt: "专为3-12岁儿童研发的营养配方，富含钙质、DHA及多种维生素，为成长关键期提供全面均衡的营养支持。",
      date: "2026-07-15",
      category: "儿童系列",
      readTime: "5分钟",
    },
    {
      id: "product-02",
      title: "爱威奶成人营养系列——忙碌生活中的健康守护",
      image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20product%20photography%20of%20a%20sleek%20milk%20carton%20with%20a%20glass%20of%20milk%20beside%20it%20on%20a%20light%20wooden%20table%20soft%20morning%20sunlight%20through%20sheer%20curtains%20cream%20background%20clean%20and%20fresh%20aesthetic&width=800&height=600&seq=cat-prod-02&orientation=landscape",
      excerpt: "满足成年人日常所需营养，富含优质蛋白和多种微量元素，帮助您在工作与生活中保持充沛精力。",
      date: "2026-07-10",
      category: "成人系列",
      readTime: "4分钟",
    },
    {
      id: "product-03",
      title: "爱威奶中老年高钙配方——骨骼健康的贴心伴侣",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20elegant%20product%20photography%20of%20a%20premium%20milk%20carton%20with%20golden%20accents%20on%20a%20cream%20colored%20marble%20surface%20soft%20warm%20lighting%20from%20the%20side%20gentle%20shadows%20minimalist%20composition&width=800&height=600&seq=cat-prod-03&orientation=landscape",
      excerpt: "专为中老年人设计的高钙低脂配方，特别添加维生素D和胶原蛋白，守护骨骼和关节健康。",
      date: "2026-07-08",
      category: "中老年系列",
      readTime: "6分钟",
    },
    {
      id: "product-04",
      title: "爱威奶运动营养系列——加速恢复，提升运动表现",
      image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20protein%20milk%20carton%20next%20to%20a%20towel%20and%20water%20bottle%20on%20a%20warm%20wooden%20surface%20soft%20natural%20light%20cream%20background%20clean%20athletic%20aesthetic&width=800&height=600&seq=cat-prod-04&orientation=landscape",
      excerpt: "专为运动爱好者打造的高蛋白配方，帮助运动后快速补充能量与蛋白质，加速肌肉恢复。",
      date: "2026-07-05",
      category: "运动营养",
      readTime: "5分钟",
    },
    {
      id: "product-05",
      title: "爱威奶低乳糖系列——让更多人享受奶香美味",
      image: "https://readdy.ai/api/search-image?query=A%20soft%20warm%20product%20photography%20of%20a%20lactose%20free%20milk%20carton%20on%20a%20cream%20colored%20ceramic%20surface%20with%20a%20small%20green%20leaf%20beside%20it%20gentle%20diffused%20natural%20light%20minimalist%20and%20pure%20composition&width=800&height=600&seq=cat-prod-05&orientation=landscape",
      excerpt: "采用先进乳糖水解技术，保留完整营养的同时解决乳糖不耐受问题，口感依然醇厚香浓。",
      date: "2026-06-28",
      category: "成人系列",
      readTime: "4分钟",
    },
    {
      id: "product-06",
      title: "爱威奶有机纯牛奶——回归自然的纯粹营养",
      image: "https://readdy.ai/api/search-image?query=Warm%20rustic%20minimalist%20product%20photography%20of%20an%20organic%20milk%20carton%20on%20a%20light%20wooden%20surface%20with%20soft%20sunlight%20and%20gentle%20shadows%20cream%20colored%20background%20with%20subtle%20natural%20texture%20clean%20composition&width=800&height=600&seq=cat-prod-06&orientation=landscape",
      excerpt: "源自有机牧场，全程无农药无添加，为您提供最纯粹、最天然的优质乳品营养体验。",
      date: "2026-06-20",
      category: "成人系列",
      readTime: "5分钟",
    },
  ],
  children: [
    {
      id: "child-01",
      title: "爱威奶儿童成长配方——科学营养助力健康成长",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20product%20photography%20of%20a%20carton%20of%20milk%20on%20a%20cream%20colored%20wooden%20surface%20with%20soft%20natural%20window%20light%20casting%20gentle%20shadows%20clean%20elegant%20composition%20with%20a%20small%20plant%20in%20background%20warm%20and%20inviting%20atmosphere&width=800&height=600&seq=cat-child-01&orientation=landscape",
      excerpt: "专为3-12岁儿童研发的营养配方，富含钙质、DHA及多种维生素，为成长关键期提供全面均衡的营养支持。",
      date: "2026-07-15",
      category: "儿童系列",
      readTime: "5分钟",
    },
    {
      id: "child-02",
      title: "爱威奶学龄前营养奶——打好成长基础第一步",
      image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20product%20photography%20of%20a%20colorful%20kids%20milk%20carton%20on%20a%20soft%20cream%20surface%20with%20gentle%20morning%20sunlight%20playful%20yet%20clean%20composition%20warm%20and%20nurturing%20atmosphere&width=800&height=600&seq=cat-child-02&orientation=landscape",
      excerpt: "针对1-3岁学龄前儿童设计，特别强化铁、锌等关键微量元素，帮助宝宝健康成长。",
      date: "2026-07-01",
      category: "儿童系列",
      readTime: "4分钟",
    },
    {
      id: "child-03",
      title: "爱威奶青少年成长配方——青春期营养专属方案",
      image: "https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20product%20photography%20of%20a%20teen%20nutrition%20milk%20carton%20with%20warm%20earthy%20tones%20on%20a%20light%20wooden%20desk%20soft%20afternoon%20light%20streaming%20through%20window%20modern%20and%20fresh%20aesthetic&width=800&height=600&seq=cat-child-03&orientation=landscape",
      excerpt: "为12-18岁青少年定制，高钙高蛋白配方满足青春期快速发育的营养需求，助力学业和运动双提升。",
      date: "2026-06-15",
      category: "儿童系列",
      readTime: "5分钟",
    },
  ],
  adult: [
    {
      id: "adult-01",
      title: "爱威奶成人营养系列——忙碌生活中的健康守护",
      image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20product%20photography%20of%20a%20sleek%20milk%20carton%20with%20a%20glass%20of%20milk%20beside%20it%20on%20a%20light%20wooden%20table%20soft%20morning%20sunlight%20through%20sheer%20curtains%20cream%20background%20clean%20and%20fresh%20aesthetic&width=800&height=600&seq=cat-adult-01&orientation=landscape",
      excerpt: "满足成年人日常所需营养，富含优质蛋白和多种微量元素，帮助您在工作与生活中保持充沛精力。",
      date: "2026-07-10",
      category: "成人系列",
      readTime: "4分钟",
    },
    {
      id: "adult-02",
      title: "爱威奶低乳糖系列——让更多人享受奶香美味",
      image: "https://readdy.ai/api/search-image?query=A%20soft%20warm%20product%20photography%20of%20a%20lactose%20free%20milk%20carton%20on%20a%20cream%20colored%20ceramic%20surface%20with%20a%20small%20green%20leaf%20beside%20it%20gentle%20diffused%20natural%20light%20minimalist%20and%20pure%20composition&width=800&height=600&seq=cat-adult-02&orientation=landscape",
      excerpt: "采用先进乳糖水解技术，保留完整营养的同时解决乳糖不耐受问题，口感依然醇厚香浓。",
      date: "2026-06-28",
      category: "成人系列",
      readTime: "4分钟",
    },
    {
      id: "adult-03",
      title: "爱威奶有机纯牛奶——回归自然的纯粹营养",
      image: "https://readdy.ai/api/search-image?query=Warm%20rustic%20minimalist%20product%20photography%20of%20an%20organic%20milk%20carton%20on%20a%20light%20wooden%20surface%20with%20soft%20sunlight%20and%20gentle%20shadows%20cream%20colored%20background%20with%20subtle%20natural%20texture%20clean%20composition&width=800&height=600&seq=cat-adult-03&orientation=landscape",
      excerpt: "源自有机牧场，全程无农药无添加，为您提供最纯粹、最天然的优质乳品营养体验。",
      date: "2026-06-20",
      category: "成人系列",
      readTime: "5分钟",
    },
  ],
  senior: [
    {
      id: "senior-01",
      title: "爱威奶中老年高钙配方——骨骼健康的贴心伴侣",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20elegant%20product%20photography%20of%20a%20premium%20milk%20carton%20with%20golden%20accents%20on%20a%20cream%20colored%20marble%20surface%20soft%20warm%20lighting%20from%20the%20side%20gentle%20shadows%20minimalist%20composition&width=800&height=600&seq=cat-senior-01&orientation=landscape",
      excerpt: "专为中老年人设计的高钙低脂配方，特别添加维生素D和胶原蛋白，守护骨骼和关节健康。",
      date: "2026-07-08",
      category: "中老年系列",
      readTime: "6分钟",
    },
    {
      id: "senior-02",
      title: "爱威奶中老年多维营养奶——全面呵护银发健康",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20gentle%20product%20photography%20of%20a%20senior%20nutrition%20milk%20carton%20on%20a%20soft%20cream%20colored%20linen%20surface%20with%20warm%20afternoon%20light%20creating%20a%20peaceful%20cozy%20atmosphere%20clean%20minimalist%20composition&width=800&height=600&seq=cat-senior-02&orientation=landscape",
      excerpt: "一罐满足多种营养需求，富含钙、铁、锌、硒及多种维生素，为中老年人提供全方位营养守护。",
      date: "2026-06-25",
      category: "中老年系列",
      readTime: "5分钟",
    },
  ],
  sport: [
    {
      id: "sport-01",
      title: "爱威奶运动营养系列——加速恢复，提升运动表现",
      image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20protein%20milk%20carton%20next%20to%20a%20towel%20and%20water%20bottle%20on%20a%20warm%20wooden%20surface%20soft%20natural%20light%20cream%20background%20clean%20athletic%20aesthetic&width=800&height=600&seq=cat-sport-01&orientation=landscape",
      excerpt: "专为运动爱好者打造的高蛋白配方，帮助运动后快速补充能量与蛋白质，加速肌肉恢复。",
      date: "2026-07-05",
      category: "运动营养",
      readTime: "5分钟",
    },
    {
      id: "sport-02",
      title: "爱威奶燃脂轻食奶——健身塑形的理想搭档",
      image: "https://readdy.ai/api/search-image?query=A%20clean%20modern%20product%20photography%20of%20a%20slim%20fitness%20milk%20carton%20with%20a%20measuring%20tape%20beside%20it%20on%20a%20light%20wooden%20surface%20soft%20gym%20lighting%20warm%20cream%20background%20motivational%20aesthetic&width=800&height=600&seq=cat-sport-02&orientation=landscape",
      excerpt: "低卡高蛋白配方，提供持久饱腹感，是健身减脂人士的理想营养补充选择。",
      date: "2026-06-18",
      category: "运动营养",
      readTime: "4分钟",
    },
  ],
  guide: [
    {
      id: "guide-01",
      title: "爱威奶正确饮用指南——这样喝效果更好",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20lifestyle%20photography%20of%20a%20person%20pouring%20milk%20into%20a%20glass%20on%20a%20sunlit%20kitchen%20counter%20cream%20colored%20interior%20soft%20morning%20light%20cozy%20and%20inviting%20atmosphere%20minimalist%20composition&width=800&height=600&seq=cat-guide-01&orientation=landscape",
      excerpt: "掌握爱威奶的正确饮用方法和最佳饮用时间，让营养吸收效果最大化。从温度到搭配，全方位指导。",
      date: "2026-07-20",
      category: "使用指南",
      readTime: "8分钟",
    },
    {
      id: "guide-02",
      title: "不同年龄段的爱威奶选择攻略",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20family%20scene%20with%20different%20milk%20products%20arranged%20on%20a%20wooden%20table%20soft%20natural%20light%20from%20window%20cream%20colored%20walls%20cozy%20home%20atmosphere%20clean%20minimalist%20lifestyle%20photography&width=800&height=600&seq=cat-guide-02&orientation=landscape",
      excerpt: "从婴幼儿到银发族，不同年龄段的营养需求各不相同。一文看懂如何为全家人选择最合适的爱威奶产品。",
      date: "2026-07-12",
      category: "使用指南",
      readTime: "7分钟",
    },
    {
      id: "guide-03",
      title: "爱威奶储存保鲜小贴士——延长新鲜口感",
      image: "https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20photography%20of%20milk%20cartons%20neatly%20arranged%20inside%20a%20refrigerator%20with%20soft%20cool%20lighting%20cream%20colored%20interior%20fresh%20and%20organized%20aesthetic%20warm%20undertones&width=800&height=600&seq=cat-guide-03&orientation=landscape",
      excerpt: "正确的储存方法能让爱威奶保持最佳口感和营养。分享专业储存保鲜建议，让每一口都新鲜如初。",
      date: "2026-07-05",
      category: "使用指南",
      readTime: "5分钟",
    },
  ],
  review: [
    {
      id: "review-01",
      title: "真实用户评测：爱威奶儿童系列半年使用感受",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20heartwarming%20photography%20of%20a%20child%20happily%20drinking%20milk%20at%20a%20sunlit%20breakfast%20table%20cream%20colored%20interior%20soft%20natural%20light%20genuine%20joyful%20moment%20minimalist%20lifestyle%20composition&width=800&height=600&seq=cat-review-01&orientation=landscape",
      excerpt: "一位妈妈分享了孩子使用爱威奶儿童系列半年的真实体验，从口味接受到体质改善，全面客观评测。",
      date: "2026-07-18",
      category: "用户评测",
      readTime: "6分钟",
    },
    {
      id: "review-02",
      title: "健身达人亲测：爱威奶运动营养系列深度评测",
      image: "https://readdy.ai/api/search-image?query=A%20clean%20modern%20fitness%20lifestyle%20photography%20of%20a%20protein%20milk%20carton%20with%20gym%20equipment%20subtly%20in%20background%20on%20a%20light%20wooden%20surface%20soft%20natural%20light%20cream%20background%20motivational%20aesthetic&width=800&height=600&seq=cat-review-02&orientation=landscape",
      excerpt: "资深健身教练对比评测爱威奶运动营养系列，从蛋白质含量、吸收率和口感三个维度给出专业评价。",
      date: "2026-07-08",
      category: "用户评测",
      readTime: "7分钟",
    },
    {
      id: "review-03",
      title: "三款热门营养奶横向对比——爱威奶表现如何？",
      image: "https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20flat%20lay%20photography%20of%20three%20different%20milk%20cartons%20arranged%20side%20by%20side%20on%20a%20cream%20colored%20surface%20with%20soft%20overhead%20lighting%20clean%20comparison%20aesthetic&width=800&height=600&seq=cat-review-03&orientation=landscape",
      excerpt: "我们将市场上三款热门营养奶产品进行了横向评测，看看爱威奶在营养成分、口感和性价比方面的真实表现。",
      date: "2026-06-30",
      category: "用户评测",
      readTime: "8分钟",
    },
  ],
};

export const getCategoryInfo = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};

export const getCategoryProducts = (slug: string) => {
  return categoryProducts[slug] || categoryProducts.all;
};